<template>
  <item-block class="cy-electricity-options">
    <base-subheader><span v-t="'Electricity project'" /></base-subheader>

    <p class="mt-5">
      <span
        v-t="
          'The lighting-, electricity- and low voltage equipment plan for your apartment can be downloaded below:'
        "
      />
    </p>

    <FileChips :items="floorElectricityPlans" />

    <small class="text--secondary">
      <span v-t="'* Please use apartment number to finc correct apartment from floor plan.'" />
    </small>

    <div v-html="$t('electricity.customize-options.description')"></div>

    <v-checkbox
      :disabled="$store.getters.isDisabled"
      v-model="isCustomizedElectricity"
      hide-details="auto"
    >
      <template #label>
        <span
          v-t="'I\'d like to change the location of sockets/luminaires or order additional cabling'"
        />
      </template>
    </v-checkbox>

    <v-expand-transition>
      <div v-if="$store.state.preferences.is_customized_electricity">
        <div class="my-2">
          <span class="text-h6" v-t="'Describe your preferences and/or upload drawing'" />
        </div>

        <base-textarea
          :id="`preferences.customize_electricity_description`"
          :error="e(`preferences.customize_electricity_description`)"
          :error-messages="$t('Please describe your preferences (or insert file below)')"
          prepend-icon="mdi-text"
          :label="$t('Describe the changes you\'d like to have')"
          outlined
          rows="4"
          :value="customizeElectricityDescription"
          @change="customizeElectricityDescription = $event"
          hide-details="auto"
          class="mb-2"
        />

        <AttachmentsInput type="electricity" :label="$t('Upload drawing')" hide-details="auto" />
        <div class="text--disabled mt-1">
          <small v-t="'You can upload multiple files'" />
        </div>
      </div>
    </v-expand-transition>
  </item-block>
</template>

<script>
import AttachmentsInput from "../AttachmentsInput";
import FileChips from "../FileChips";
export default {
  components: {
    FileChips,
    AttachmentsInput,
  },

  computed: {
    /*  */
    isCustomizedElectricity: {
      get() {
        return this.$store.state.preferences.is_customized_electricity;
      },
      set(value) {
        this.$store.dispatch("setPreference", { is_customized_electricity: value });
      },
    },

    /*  */
    customizeElectricityDescription: {
      get() {
        return this.$store.state.preferences.customize_electricity_description;
      },
      set(value) {
        this.$store.dispatch("setPreference", { customize_electricity_description: value });
      },
    },

    /*  */
    floorElectricityPlans() {
      return (
        this.$store.state.options.floor_electricity_plans
          //   Get all results for specific floor
          .filter((item) => parseInt(item.floor) === parseInt(this.$store.getters.apartment.floor))
      );
    },
  }, // computed

  methods: {
    e(key) {
      return this.$store.getters["visibleError"]("Electricity", key);
    },
  },
};
</script>
